module.exports = __webpack_public_path__ + "static/img/star-off.77e5c7b7.svg";